import { COLOURS } from '@core-ui/styles';

// Primary CTA gradient stops
const SUNSET_1 = '#EC4899'; // pink
const SUNSET_2 = '#A855F7'; // purple
const SUNSET_3 = '#6366F1'; // indigo

export const TOKENS = {
  common: {
    black: 'black',
    white: 'white',
    clear: 'transparent',
  },
  callToAction: {
    brandPrimary: COLOURS.Fig.Solid[600],
    brandSecondary: COLOURS.Coconut.Solid[900],

    sunset: {
      primary: SUNSET_1,
      secondary: SUNSET_2,
      tertiary: SUNSET_3,
    },

    hover: {
      primary: COLOURS.Fig.Solid[500],
      secondary: COLOURS.Coconut.Solid[700],
    },
  },
  borders: {
    border: COLOURS.Coconut.Solid[200],
    divider: COLOURS.Coconut.Solid[300],
    outline: COLOURS.WHITE,
  },
  label: {
    title: COLOURS.Coconut.Solid[900],
    body: COLOURS.Coconut.Solid[800],
    caption: COLOURS.Coconut.Solid[600],
    inverse: COLOURS.WHITE,
    white: COLOURS.WHITE,
  },
  layers: {
    primary: COLOURS.WHITE,
    secondary: COLOURS.Coconut.Solid[50],
    tertiary: COLOURS.Coconut.Solid[100],
    quaternary: COLOURS.Coconut.Solid[200],
    alpha: {
      a24: COLOURS.Coconut.Alpha['500A24'],
      a16: COLOURS.Coconut.Alpha['500A16'],
      a8: COLOURS.Coconut.Alpha['500A8'],
    },
  },
  disabled: {
    layers: {
      300: COLOURS.Coconut.Solid[300],
      500: COLOURS.Coconut.Solid[500],
      50: COLOURS.Coconut.Solid[50],
    },
    label: {
      500: COLOURS.Coconut.Solid[500],
    },
    border: {
      200: COLOURS.Coconut.Solid[200],
      400: COLOURS.Coconut.Solid[400],
    },
  },
  background: {
    primary: COLOURS.WHITE,
  },
  overlay: {
    primary: COLOURS.Coconut.Alpha['900A72'],
    second: COLOURS.Coconut.Alpha['900A16'],
  },
  shadows: {
    primary: COLOURS.Coconut.Alpha['900A72'],
    second: COLOURS.Coconut.Alpha['900A72'],
    tertiary: COLOURS.Coconut.Alpha['900A8'],
  },
  accents: {
    fig: {
      900: COLOURS.Fig.Solid[900],
      700: COLOURS.Fig.Solid[700],
      600: COLOURS.Fig.Solid[600],
      hover500: COLOURS.Fig.Solid[500],
      100: COLOURS.Fig.Solid[100],
      hover50: COLOURS.Fig.Solid[50],
      a24: COLOURS.Fig.Alpha['500A24'],
      a16: COLOURS.Fig.Alpha['500A16'],
      a8: COLOURS.Fig.Alpha['500A8'],
    },
  },
  flightsType: {
    charter: {
      base: COLOURS.Avocado.Solid[600],
      label: COLOURS.Avocado.Solid[900],
      layer: {
        100: COLOURS.Avocado.Solid[100],
        a8: COLOURS.Avocado.Alpha['500A8'],
      },
    },
    owner: {
      base: COLOURS.Passionfruit.Solid[600],
      label: COLOURS.Passionfruit.Solid[900],
      layer: {
        100: COLOURS.Passionfruit.Solid[100],
        a8: COLOURS.Passionfruit.Alpha['500A8'],
      },
    },
  },
};
